import React, { useRef } from "react";
import { StandaloneSearchBox } from "@react-google-maps/api";
import BaseTextField from "../ui/BaseTextField";
import { useDispatch, useSelector } from "react-redux";
import { updateWorkOrderFormValidation } from "../../store/workOrder/workOrderSlice";
import { fetchCountryByCode } from "../../services/api/country";

function SearchLocation({
  onPlaceSelected,
  label = "Search Address",
  isDefaultField = false,
  labelShrink = false,
  value,
  ...props
}) {
  const inputRef = useRef(null);
  const lastSelectedAddressRef = useRef("");

  const dispatch = useDispatch();
  const workOrderFormValidation = useSelector((state) => state.workOrder.workOrderFormValidation);
  const fetchCountry = async (code) => {
    try {
      const res = await fetchCountryByCode(code);
      return res?.data;
    } catch (err) {
      console.error("Error fetching country:", err);
      return null;
    }
  };
  // Fetch the location's time zone from Google API
  const fetchLocationTimeZone = async (longitude, latitude) => {
    const timestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
    const timeZoneUrl = `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${timestamp}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

    try {
      const response = await fetch(timeZoneUrl);
      const timeZoneData = await response.json();

      return {
        timeZone: timeZoneData.timeZoneId,
        timeZoneName: timeZoneData.timeZoneName,
      };
    } catch (error) {
      console.error("Error fetching time zone data:", error);
      return {};
    }
  };

  // Handle the place selection and extract details
  const handleOnPlacesChanged = async () => {
    if (inputRef.current && inputRef.current.getPlaces) {
      const places = inputRef.current.getPlaces();

      if (places && places.length > 0) {
        const place = places[0];
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();

        const addressComponents = place?.address_components?.reduce((acc, component) => {
          const type = component.types[0];
          if (type === "postal_code") acc.zipCode = component.long_name;
          if (type === "country") {
            acc.country = component.long_name;
            acc.countryCode = component.short_name;
          }
          if (type === "locality" || type === "sublocality") acc.city = component.long_name;
          if (type === "administrative_area_level_1") acc.state = component.long_name;
          if (type === "administrative_area_level_2") acc.area = component.long_name;
          return acc;
        }, {});
        let countryDetails = null;
        if (addressComponents?.countryCode) {
          countryDetails = await fetchCountry(addressComponents.countryCode);
        }
        const timeZone = await fetchLocationTimeZone(longitude, latitude);

        const location = {
          place,
          completeAddress: place.formatted_address,
          latitude,
          longitude,
          ...timeZone,
          ...addressComponents,
          country: countryDetails?.name?.common || addressComponents?.country || "",
        };
        lastSelectedAddressRef.current = place.formatted_address;
        if (onPlaceSelected) {
          onPlaceSelected(location);
        }
      }
    }
  };

  return (
    <StandaloneSearchBox
      onLoad={(ref) => (inputRef.current = ref)}
      onPlacesChanged={handleOnPlacesChanged}
      onClick={(e) => e.stopPropagation()}
    >
      <BaseTextField
        style={{
          zIndex: "1000 !important",
        }}
        error={workOrderFormValidation.addressLine1}
        errorMsg="Location is required"
        fullWidth
        fullHeight={false}
        label={label}
        placeholder=""
        optional={false}
        // value={value}
        labelShrink={labelShrink}
        onChange={(e) => {
          const val = e.target.value;

          if (val !== lastSelectedAddressRef.current) {
            onPlaceSelected?.({
              completeAddress: "",
              city: "",
              state: "",
              country: "",
              zipCode: "",
              latitude: "",
              longitude: "",
              timeZone: "",
              timeZoneName: "",
            });
          }

          if (val) {
            dispatch(
              updateWorkOrderFormValidation({
                fieldName: "addressLine1",
                data: false,
              }),
            );
          } else {
            dispatch(
              updateWorkOrderFormValidation({
                fieldName: "addressLine1",
                data: true,
              }),
            );
          }
        }}
        /*  onBlur={() => {
          dispatch(
            updateWorkOrderFormValidation({
              fieldName: "addressLine1",
              data: false,
            })
          );
        }} */
        {...props}
        isDefaultField={isDefaultField}
      />
    </StandaloneSearchBox>
  );
}

export default React.memo(SearchLocation);
